import React, {
    createContext,
    useContext,
    useEffect,
    useState,
    useCallback,
} from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Configure axios to send cookies for cross-site requests
axios.defaults.withCredentials = true;

const AuthContext = createContext({
    user: null,
    loading: true,
    refresh: async () => {},
    logout: async () => {},
    setUser: () => {},
});

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const token = localStorage.getItem("session_token");
            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            const res = await axios.get(`${API}/auth/me`, { headers });
            setUser(res.data);
        } catch {
            setUser(null);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        // CRITICAL: If returning from Emergent OAuth (session_id in fragment), skip /me check.
        // AuthCallback will exchange the session_id and establish the session first.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh();
    }, [refresh]);

    const logout = useCallback(async () => {
        try {
            const token = localStorage.getItem("session_token");
            const headers = token ? { Authorization: `Bearer ${token}` } : {};
            await axios.post(`${API}/auth/logout`, {}, { headers });
        } catch {
            // ignore
        }
        localStorage.removeItem("session_token");
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider
            value={{ user, loading, refresh, logout, setUser }}
        >
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
export { API };
